import { render } from "./ArtistCard.vue?vue&type=template&id=b4390f28"
import script from "./ArtistCard.vue?vue&type=script&lang=js"
export * from "./ArtistCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__